// https://vuex.vuejs.org/en/actions.html

import pwsSecurity from 'pws-security'

const actions = {
    ACTION_LOGIN: (context, data) => {
        context.commit("LOGOUT");
        return pwsSecurity
            .login(data.username, data.password)
            .then(response => {
                const profile = {
                    office: response.data.office,
                    role: response.data.role,
                    roleTds: response.data.roleTds,
                    username: response.data.username,
                    language: response.data.language,
                    privacyAccepted: response.data.privacyAccepted
                };
                context.commit("SET_PROFILE", profile);
                context.commit("SET_TOKEN", response.data.token);
                // context.commit("INITIALIZE_STORAGE", context);
            });
    },
    ACTION_LOGOUT: context => {
        context.commit("LOGOUT", context);
    },
    ACTION_STARTUP: context => {
        context.commit("SET_STATE_FROM_STORAGE");
    },
    ACTION_GET_TOKEN: context => {
        context.commit("GET_TOKEN");
    },
    ACTION_PROFILE: (context, profile) => {
        context.commit("SET_PROFILE", profile);
    },
    ACTION_SET_LOCALE: (context, locale) => {
        context.commit("SET_LOCALE", locale);
    }
};

export default actions;
//
